import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

export default function ArrowWithTailLeftThin({
  className,
  fillPrimary = colors.neutral10,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[24px] w-[24px]', className)}
    >
      <path
        d="M5.04353 11.2621C4.63602 11.2621 4.30568 11.5924 4.30568 11.9999C4.30568 12.3704 4.57869 12.6771 4.93449 12.7298L5.04353 12.7378H18.9565C19.364 12.7378 19.6943 12.4074 19.6943 11.9999C19.6943 11.6295 19.4213 11.3228 19.0655 11.2701L18.9565 11.2621H5.04353Z"
        fill={fillPrimary}
      />
      <path
        d="M4.52176 11.4778C4.25762 11.7419 4.23561 12.1565 4.45572 12.4457L4.52176 12.5212L7.99999 15.9995C8.28814 16.2876 8.75532 16.2876 9.04346 15.9995C9.3076 15.7353 9.32961 15.3208 9.1095 15.0316L9.04346 14.956L6.08696 11.9995L9.04346 9.04299C9.3076 8.77886 9.32961 8.36429 9.1095 8.07508L9.04346 7.99952C8.77933 7.73538 8.36476 7.71337 8.07555 7.93349L7.99999 7.99952L4.52176 11.4778Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
